// Public contact details (home page, footer). Support is handled through the chat assistant and the Contact Us form only,
// so no phone number or email address is published here.
export const CONTACT = {
    location: 'Puducherry, Tamil Nadu, India',
    hours: 'Monday to Saturday, 9 AM to 6 PM IST',
};
